import { PropsWithChildren } from 'react';

interface ConditionalWrapRenderProps {
  condition: boolean;
  wrapper: any;
}

const ConditionalWrapRender = <T,>(props: PropsWithChildren<ConditionalWrapRenderProps & T>) => {
  const { condition, wrapper, children } = props;
  return condition ? wrapper({ children, ...props }) : children;
};

export default ConditionalWrapRender;
